import { Component, OnInit, Input, Inject, computed } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { IAppUserNotificationsService } from '../app-user-notifications/app-user-notifications.service';
import { APP_USER_NOTIFICATIONS_SERVICE_TOKEN } from '../app-user-notifications/app-user-notifications-config';
import { NotificationItemDTO } from '../app-user-notifications/app-user-notifications.models';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  imports: [
    MatIconModule,
    MatListModule,
    RouterModule
  ]
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel: any;

  // computed signal that filters unread notifications
  public notifications = computed(() =>
    this.notificationsService.notifications$().filter((notification: NotificationItemDTO) => !notification.isRead)
  );

  constructor(private router: Router,
    @Inject(APP_USER_NOTIFICATIONS_SERVICE_TOKEN) public notificationsService: IAppUserNotificationsService) { }

  ngOnInit() {
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
      }
    });
  }
}
